import React, { PureComponent } from "react";
import t from "@zendesk/client-i18n-tools";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import { Pagination } from "@zendeskgarden/react-pagination";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import Author from "components/Author";
import { updateArticleMatchesPageMutation } from "mutations/updateArticleMatchesPageMutation";
import pageToCursor from "utils/pageToCursor";
import NoResults from "./NoResults";
import SearchFailure from "./SearchFailure";
import prepareFilters from "utils/prepareFilters";

import {
  Body,
  Cell,
  Head,
  HeaderCell,
  HeaderRow,
  Row,
  Table,
} from "@zendeskgarden/react-tables";

import styles from "./styles.css";

const dirtyStateQuery = gql`
  query {
    articleMatchesPage @client
    dirtyState @client {
      filters {
        id
        type
        value
      }
    }
  }
`;

const PAGE_SIZE = 15;

const articleQuery = gql`
  query ArticleMatches(
    $first: Int
    $after: String
    $filter: ArticlesQueryFilterInput
  ) {
    articles(first: $first, after: $after, filter: $filter) {
      edges {
        node {
          id
          author {
            email
            name
            avatar
          }
          sourceTranslation {
            locale
            title
          }
          updated {
            datetime
          }
        }
      }
      total
    }
  }
`;

export default class ArticleMatches extends PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.table}>
          <Query query={dirtyStateQuery}>
            {({
              data: {
                dirtyState: { filters },
                articleMatchesPage,
              },
            }) => {
              return (
                <Query
                  query={articleQuery}
                  variables={{
                    first: PAGE_SIZE,
                    after: pageToCursor(articleMatchesPage, PAGE_SIZE),
                    filter: prepareFilters(filters),
                  }}
                >
                  {({ loading, error, data }) => {
                    if (error) return <SearchFailure />;

                    const { articles = { edges: [], total: 0 } } = data;

                    if (!loading && articles.edges.length === 0) {
                      return <NoResults />;
                    }

                    const totalPages = Math.ceil(articles.total / PAGE_SIZE);

                    // TODO show loading page

                    return (
                      <React.Fragment>
                        <h2 className={styles.title}>
                          {t("knowledge-verification.totalAffected", {
                            count: articles.total,
                          })}
                        </h2>
                        <Table>
                          <Head>
                            <HeaderRow>
                              <HeaderCell width="60%">
                                {t("knowledge-verification.table.articleName")}
                              </HeaderCell>
                              <HeaderCell width="20%">
                                {t("knowledge-verification.table.lastEdited")}
                              </HeaderCell>
                              <HeaderCell width="20%">
                                {t("knowledge-verification.table.author")}
                              </HeaderCell>
                            </HeaderRow>
                          </Head>
                          <Body>
                            {articles.edges.map(({ node }) => (
                              <Row key={node.id}>
                                <Cell width="60%" className={styles.cell}>
                                  <span className={styles.ellipsis}>
                                    {node.sourceTranslation.title}
                                  </span>
                                </Cell>
                                <Cell width="15%" className={styles.cell}>
                                  {t
                                    .relativeFormat()
                                    .format(new Date(node.updated.datetime))}
                                </Cell>
                                <Cell width="25%" className={styles.cell}>
                                  <Author {...node.author} />
                                </Cell>
                              </Row>
                            ))}
                          </Body>
                          {totalPages > 1 && (
                            <React.Fragment>
                              <Gap.Large vertical />
                              <Mutation
                                mutation={updateArticleMatchesPageMutation}
                              >
                                {mutate => (
                                  <Pagination
                                    className={styles.pagination}
                                    totalPages={totalPages}
                                    currentPage={articleMatchesPage}
                                    onChange={page =>
                                      mutate({ variables: { page } })
                                    }
                                  />
                                )}
                              </Mutation>
                            </React.Fragment>
                          )}
                        </Table>
                      </React.Fragment>
                    );
                  }}
                </Query>
              );
            }}
          </Query>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleMatches/index.js